import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import {
  ShipmentTransportOrderNotificationsLoad,
  ShipmentTransportOrderNotificationsSetInitialState,
} from './shipment-transport-order-notifications.actions';
import { ShipmentTransportOrderNotificationsService } from './shipment-transport-order-notifications.service';
import { ShipmentTransportOrderNotificationsModel } from '../../models/shipment-transport-order-notifications.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderNotificationsStateModel {
  notifications: ShipmentTransportOrderNotificationsModel[];
  loaded: boolean;
}

const initialState: ShipmentTransportOrderNotificationsStateModel = {
  notifications: null,
  loaded: false,
};

@State<ShipmentTransportOrderNotificationsStateModel>({
  name: 'shipmentTransportOrderNotifications',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderNotificationsState {
  constructor(
    private shipmentTransportOrderNotificationsService: ShipmentTransportOrderNotificationsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: ShipmentTransportOrderNotificationsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getNotifications(
    state: ShipmentTransportOrderNotificationsStateModel,
  ): ShipmentTransportOrderNotificationsModel[] {
    return state.notifications;
  }

  @Action(ShipmentTransportOrderNotificationsLoad)
  getShipmentTransportOrderNotifications(
    ctx: StateContext<ShipmentTransportOrderNotificationsStateModel>,
    { payload }: ShipmentTransportOrderNotificationsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderNotificationsService.getShipmentTransportOrderNotifications(payload).pipe(
      map((notifications: ShipmentTransportOrderNotificationsModel[]) => {
        ctx.patchState({ notifications, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderNotificationsSetInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderNotificationsStateModel>): void {
    ctx.setState(initialState);
  }
}
